var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-base',{attrs:{"width":100+'%',"fill":_vm.color,"viewBox":"0 0 643.95 505.586"}},[_c('path',{attrs:{"id":"Path_3075","data-name":"Path 3075","d":"M113.4,1611.421s70.029-190.78,281.966-142.973c249.547,56.29,327.473-43.228,359.6-168.937l2.388,497.654S113.4,1863.695,113.4,1611.421Z","transform":"translate(-113.399 -1299.511)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }